module.exports = __webpack_public_path__ + "static/media/yeutech_bill.57f56941.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/yeutech_bill.jpeg
// module id = 243
// module chunks = 0